//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	props: {
		paymentMethods: {
			type: Array
		}
	},
	data: function data() {
		return {};
	},

	methods: {
		getMethodData: function getMethodData(p) {
			if (p.type) {
				// Credit card
				return "<strong>Last Four:</strong> " + p.last_four + "<br /><strong>Type:</strong> " + p.type;
			} else {
				// ACH
				return "<strong>Last Four:</strong> " + p.last_4 + "<br /><strong>Bank:</strong> " + p.bank_name + "<br /><strong>Account Type:</strong> " + p.account_type;
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/payments/PaymentMethods.vue
// module id = MQSG
// module chunks = 0 1